import type { ReactElement } from 'react';

import { ModelProfileCard } from '../dashboard/ModelProfileCard.js';
import { StorefrontAppearanceCard } from './StorefrontAppearanceCard.js';
import { SettingsStack } from './SettingsStack.js';

export function SettingsProfilePage(): ReactElement {
  return (
    <SettingsStack titleKey="common.studio.settings.profileTitle" hintKey="common.studio.settings.profileHint">
      <ModelProfileCard />
      <StorefrontAppearanceCard />
    </SettingsStack>
  );
}
